const BASE_URL = "https://api.starmallonline.com/api/v1/";   

export default BASE_URL;
